import PropTypes from 'prop-types';
import React from 'react';
import EntityUrlText from '../Products/EntityUrlText';

const ReportProductUrlText = ({ entity }) => {
    return <EntityUrlText entity={entity.product} />;
};

export default ReportProductUrlText;

ReportProductUrlText.propTypes = {
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
};
